<template>
    <form
        class="o-login"
        @submit.prevent="handleSubmit"
    >
        <p class="a-title o-login__title">Reset hasła</p>
        <div>
            <p class="a-label o-login__label">Hasło</p>
            <div class="a-control o-login__inputPassword">
                <input
                    class="a-control__input o-login__input"
                    type="password"
                    placeholder="Wpisz hasło..."
                    v-model="password"
                    ref="authResetPasswordStep2Password"
                    autocomplete="new-password"
                >
            </div>
            <br />
            <p class="a-label o-login__label">Powtórz hasło</p>
            <div class="a-control o-login__inputPassword">
                <input
                    class="a-control__input o-login__input"
                    type="password"
                    placeholder="Wpisz hasło..."
                    v-model="passwordRepeat"
                    ref="authResetPasswordStep2PasswordRepeat"
                    autocomplete="new-password"
                >
            </div>
        </div>
        <div>
            <a-button
                class="o-login__button"
                type="fullwidth-light"
                :submit="true"
                :is-processing="authStatus === 'pending'"
            >
                Zmień hasło
            </a-button>
            <p class="o-login__version">
                v{{ version }}
                <span v-if="environment !== 'production'">{{ environment }}</span>
            </p>
        </div>
    </form>
</template>

<script>
export default {
    metaInfo: {
        title: 'Reset hasła'
    },
    data() {
        return {
            password: '',
            passwordRepeat: ''
        }
    },
    computed: {
        version() {
            return process.env.PACKAGE_VERSION
        },
        environment() {
            return process.env.VUE_APP_MODE
        },
        authStatus() {
            return this.$store.getters.authStatus
        }
    },
    methods: {
        addNotification(content) {
            this.$store.dispatch('addNotification', {
                type: 'alert',
                content
            })
            this.$refs.authResetPasswordStep2Password.focus()
        },
        handleSubmit() {
            if(this.password === '') {
                this.addNotification('Uzupełnij wymagane pole "Hasło"')
            } else if(this.password.length <= 7) {
                this.addNotification('Podane hasło jest za krótkie')
            } else if(this.password.length > 64) {
                this.addNotification('Podane hasło jest za długie')
            } else if(this.passwordRepeat === '') {
                this.addNotification('Uzupełnij wymagane pole "Powtórz hasło"')
            } else if(this.password !== this.passwordRepeat) {
                this.addNotification('Podane hasła różnią się')
            } else {
                this.$store.dispatch('authResetPasswordStep2', {
                    guid: this.$route.params.token,
                    password: this.password,
                    password_repeat: this.passwordRepeat
                }).then(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Hasło zostało zmienione.'
                    })
                    this.$router.push({ name: 'login' })
                }).catch(error => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                    console.error(error)
                })
            }
        }
    }
}
</script>
